import React, {useEffect} from 'react';
import {useSetting} from "store/settings";
import {handleSuccessMessages} from "store/auth";
import {Field, Form, Formik} from "formik";
import {Loading, TextField} from "components/form";

const Socials = (props) => {
   const {dispatch, getSetting, submitSetting, socials, loading} = useSetting();
   const key = "socials"

   useEffect(() => {
      dispatch(getSetting(key));
   }, [])

   if (loading) {
      return (<div className="box p-5 flex justify-center">
         <Loading/>
      </div>)
   }

   return (
      <>
         <Formik
            initialValues={socials || {}}
            onSubmit={async (values, {setSubmitting}) => {
               await dispatch(submitSetting({value: values, key},
                  () => handleSuccessMessages("ویرایش اطلاعات انجام شد")))
               setSubmitting(false);
            }}
            enableReinitialize
         >
            {({isSubmitting, dirty}) => (
               <Form>
                  <div className="box rounded p-3">
                     <h3>تنظیمات شبکه های اجتماعی</h3>
                     <hr className="my-2"/>
                     <div className="">
                        <div className="intro-x grid grid-cols-2 gap-4">
                           <Field
                              placeholder="سروش"
                              label="سروش :"
                              name="sapp"
                              component={TextField}
                           />
                           <Field
                              placeholder="گپ"
                              label="گپ :"
                              name="gap"
                              component={TextField}
                           />
                           <Field
                              placeholder="لینکدین"
                              label="لینکدین :"
                              name="linkedin"
                              component={TextField}
                           />
                           <Field
                              placeholder="یوتوب"
                              label="یوتوب :"
                              name="youtube"
                              component={TextField}
                           />
                           <Field
                              placeholder="فیسبوک"
                              label="فیسبوک :"
                              name="facebook"
                              component={TextField}
                           />
                           <Field
                              placeholder="توئیتر"
                              label="توئیتر :"
                              name="twitter"
                              component={TextField}
                           />
                           <Field
                              placeholder="اینستاگرام"
                              label="اینستاگرام :"
                              name="instagram"
                              component={TextField}
                           />
                           <Field
                              placeholder="تلگرام"
                              label="تلگرام :"
                              name="telegram"
                              component={TextField}
                           />
                           <Field
                              placeholder="ویمو"
                              label="ویمو :"
                              name="vimo"
                              component={TextField}
                           />
                           
                           <Field
                              placeholder="آپارات"
                              label="آپارات :"
                              name="aparat"
                              component={TextField}
                           />

                           <button
                              className="mt-4 btn btn-primary w-20"
                              type="submit"
                              disabled={!!(isSubmitting || !dirty)}
                           >
                              {isSubmitting ? <Loading/> : "ذخیره"}
                           </button>
                        </div>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
      </>
   )
};

export default Socials;